import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SidebarService } from './service/sidebarservice.service';
import { Navbar } from './layout/navbar/navbar';
import { Sidebar } from './layout/sidebar/sidebar';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navbar, Sidebar],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly titleService = inject(Title);
  protected readonly title = signal('admin-core-frontend');
  private router = inject(Router);
   sidebar = inject(SidebarService);

  constructor() {
    this.titleService.setTitle(environment.applicationTitle);
  }

  isLoginRoute(): boolean {
    const authRoutes = ['/signin', '/forgot-password'];
    const currentRoute = this.router.url.split('?')[0].split('#')[0];
    return authRoutes.includes(currentRoute);
  }
}
